import _implicitStylesheets from "./accordionRow.css";
import _implicitScopedStylesheets from "./accordionRow.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "slds-grid": true,
  "slds-grid_vertical-align-center": true,
  "container": true,
  "list-items": true
};
const stc1 = {
  classMap: {
    "slds-m-left_x-small": true,
    "icon": true
  },
  key: 1
};
const stc2 = {
  attrs: {
    "name": "summaryIcon"
  },
  key: 2
};
const stc3 = [];
const stc4 = {
  attrs: {
    "name": "summary"
  },
  key: 3
};
const stc5 = {
  "icon": true,
  "slds-m-right_medium": true,
  "icon-versions": true
};
const stc6 = {
  attrs: {
    "data-testid": "arrow-up"
  },
  props: {
    "iconName": "utility:chevronup",
    "size": "x-small",
    "iconClass": "normal",
    "tabIndex": "0"
  },
  key: 5
};
const stc7 = {
  attrs: {
    "data-testid": "arrow-down"
  },
  props: {
    "iconName": "utility:chevrondown",
    "size": "x-small",
    "iconClass": "normal",
    "tabIndex": "0"
  },
  key: 6
};
const stc8 = {
  attrs: {
    "name": "detail"
  },
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, s: api_slot, h: api_element, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    key: 0,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.toggle))
    }
  }, [api_element("div", stc1, [api_slot("summaryIcon", stc2, stc3, $slotset)]), api_slot("summary", stc4, stc3, $slotset), !$cmp.hideArrowIcon ? api_element("div", {
    classMap: stc5,
    key: 4,
    on: {
      "keypress": _m1 || ($ctx._m1 = api_bind($cmp.toggle))
    }
  }, [$cmp.isOpen ? api_custom_element("c360-icon", _c360Icon, stc6) : null, !$cmp.isOpen ? api_custom_element("c360-icon", _c360Icon, stc7) : null]) : null]), $cmp.isOpen ? api_slot("detail", stc8, stc3, $slotset) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["detail", "summary", "summaryIcon"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-mugegtghod";
tmpl.legacyStylesheetToken = "appx-accordionRow_accordionRow";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
